import * as _ from 'underscore';

import WebHttpClient from '../../httpClient/WebHttpClient';
import { GetLicensingInfoRequest, IGetLicensingInfoResult } from '../ServerApi/requests/GetLicensingInfoRequest';
import { GetServerLicensingConsumptionInfoRequest } from '../ServerApi/requests/GetServerLicensingConsumptionInfoRequest';
import { GetSiteLicensingConsumptionInfoRequest } from '../ServerApi/requests/GetSiteLicensingConsumptionInfoRequest';
import { HasSiteLicensingConsumptionInfoRequest } from '../ServerApi/requests/HasSiteLicensingConsumptionInfoRequest';
import { ILicenseConsumptionInfo } from '../ServerApi/types/ILicenseConsumptionInfo';
import { ICoreLicensingInfo, ILicensingInfo } from '../ServerApi/types/ILicensingInfo';

export interface ILicensingInfoWithTotals extends ILicensingInfo {
  totalLicensedRegularCores?: number;
  totalLicensedPrepCores?: number;
  totalRegularCoreLicensesAvailable?: number;
  totalPrepCoreLicensesAvailable?: number;
  totalSeatLicenses?: number;
}

export function fetch(): Promise<ILicensingInfoWithTotals> {
  return WebHttpClient.sendRequest(new GetLicensingInfoRequest())
    .then((result: IGetLicensingInfoResult): ILicensingInfoWithTotals => {
      if (result.coreLicensingInfos) { //Core license
        const totalLicensedRegularCores = _.reduce(result.coreLicensingInfos,
          (memo: number, info: ICoreLicensingInfo) => memo + info.numLicensedCores, 0);
        const totalLicensedPrepCores = _.reduce(result.coreLicensingInfos,
          (memo: number, info: ICoreLicensingInfo) => memo + info.numLicensedPrepCores, 0);
        const totalRegularCoreLicensesAvailable = (result.totalCoreLicenses - totalLicensedRegularCores);
        const totalPrepCoreLicensesAvailable = (result.totalPrepCoreLicenses - totalLicensedPrepCores);
        return _.extend(result,
            {
              totalLicensedRegularCores: totalLicensedRegularCores,
              totalLicensedPrepCores: totalLicensedPrepCores,
              totalRegularCoreLicensesAvailable: totalRegularCoreLicensesAvailable,
              totalPrepCoreLicensesAvailable: totalPrepCoreLicensesAvailable
            }
          );
      }
      return result;
    });
}

export function  fetchCapacityInfoForInfoBar(): Promise<ILicenseConsumptionInfo> {
  return WebHttpClient.sendRequest(new GetServerLicensingConsumptionInfoRequest());
}

export function fetchSiteScopedCapacityInfoForInfoBar(): Promise<ILicenseConsumptionInfo> {
  return WebHttpClient.sendRequest(new GetSiteLicensingConsumptionInfoRequest());
}

export function hasSiteLicensingConsumptionInfo(): Promise<boolean> {
  return WebHttpClient.sendRequest(new HasSiteLicensingConsumptionInfoRequest());
}